var Request = require('./helper/request');

function User(app){
	var self = this;
  self.request = new Request(app);

  self.routes = {
  	register: {
  		url: '/users/register',
  		method: 'GET'
  	},
  	update: {
  		url: '/users/update',
  		method: 'GET'
  	}
  };
}

User.prototype.register = function(data){
  var self = this;
  return self.request.post(self.routes.register.url, {
    email: data
  });
};

User.prototype.update = function(data){
  var self = this;
  return self.request.post(self.routes.update.url, {
    email: data
  });
};

module.exports = User;